import React from 'react';
import { Redirect } from 'react-router-dom';

class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { redirect: false };
    this.handleSubmit = (event) => {
      this.props.handleSubmit(event);
      this.setState({ redirect: true });
    };
    this.fileInput = this.props.fileInput;
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/send' />;
    }
    return (
      <form onSubmit={this.handleSubmit} className='send-form'>
        <label>
          Choose file to transfer:
          <input type='file' ref={this.fileInput} multiple />
        </label>
        <br />
        <button type='submit' className='btn btn-primary'>
          Send
        </button>
      </form>
    );
  }
}

export default FileInput;
